import { Component, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl } from '@angular/forms';
import { FormErrorComponent } from '../form-error/form-error.component';

export interface RadioOption {
  value: any;
  label: string;
  disabled?: boolean;
}

@Component({
  selector: 'is-radio-field',
  standalone: true,
  imports: [CommonModule, FormErrorComponent],
  templateUrl: './radio-field.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioFieldComponent),
      multi: true,
    },
  ],
})
export class RadioFieldComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() options: RadioOption[] = [];
  @Input() inline = false;
  @Input() control: AbstractControl | null = null;

  private static idCounter = 0;
  readonly groupName = `is-radio-${++RadioFieldComponent.idCounter}`;

  value: any = null;
  isDisabled = false;

  private onChange: (val: any) => void = () => {};
  private onTouched: () => void = () => {};

  get hasError(): boolean {
    return !!(this.control?.invalid && (this.control?.dirty || this.control?.touched));
  }

  writeValue(val: any): void {
    this.value = val;
  }

  registerOnChange(fn: (val: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.isDisabled = disabled;
  }

  handleChange(optionValue: any): void {
    this.value = optionValue;
    this.onChange(optionValue);
    this.onTouched();
  }

  isChecked(optionValue: any): boolean {
    return this.value === optionValue;
  }

  trackByValue(_: number, opt: RadioOption): any {
    return opt.value;
  }
}
